import left from "../../../assets/documents/leftVector.svg";
import right from "../../../assets/documents/rightVector.svg";
import { unsetUserRequestAction } from "../../../redux/actions/Requests/CurrentRequest/unsetUserRequest.action";
import {
    setCurrentRequestThunkAction,
} from "../../../redux/actions/Requests/CurrentRequest/thunk/setCurrentRequest.thunk.action";

import { setCurrentRequestAction } from "../../../redux/actions/Requests/CurrentRequest/setCurrentRequest.action";
import RequestServices from "../../../frontend.services/RequestServices/RequestServices";
import {
    getCurrentLeaderRequestThunkAction,
} from "../../../redux/actions/Requests/LeaderRequests/thunk/getCurrentLeaderRequest.thunk.action";

import { unsetCurrentDocumentAction } from "../../../redux/actions/Requests/CurrentRequest/setCurrentDocument.action";

import {
    getGroupCurrentRequestThunkAction,
} from "../../../redux/actions/CurrentDocument/thunk/getGroupCurrentRequest.thunk.action";

import { getLocalTripDetailThunk } from "../../../redux/actions/LocalTrips/thunk/LocalTrips.thunk.action";

import {
    getIndividualCoefficientCardThunkAction,
} from "../../../redux/actions/Requests/RequestsFromLeader/IndividualCoefficients/getIndividualCoefficientCardThunkAction";

import { useDispatch } from "react-redux";

const SwitchRequests = (props) => {
    console.log(props);

    const dispatch = useDispatch();

    function switchHandler(side, uid) {
        console.log(side, uid);

        const index = props.userRequests?.items?.findIndex(el => el.uid === uid);
        if (index || index === 0 || index !== props.userRequests?.items?.length - 1) {
            if (side === "left" && index !== 0) {

                dispatch(unsetCurrentDocumentAction());
                dispatch(unsetUserRequestAction());
                if (props.isLeader) {
                    if (props.userRequests.items[index - 1].type === 22) {
                        dispatch(getIndividualCoefficientCardThunkAction(
                            props.userRequests.items[index - 1].uid,
                            { setDescription: props.setDescription },
                        ));
                    } else if (props.userRequests.items[index - 1].entityType.code === "request:local-trip") {
                        dispatch(getLocalTripDetailThunk(props.userRequests.items[index - 1].uid, { setDescription: props.setDescription }));

                    } else {
                        dispatch(getCurrentLeaderRequestThunkAction(props.userRequests.items[index - 1].uid, false, { setDescription: props.setDescription }));
                    }
                } else {
                    if (props.userRequests.items[index - 1].type === 22) {
                        dispatch(getIndividualCoefficientCardThunkAction(
                            props.userRequests.items[index - 1].uid,
                            {
                                setDescription: props.setDescription,
                                markReviewed: true,
                                isReviewed: props.userRequests.items[index - 1].isReviewed,
                            },
                        ));
                    } else if (props.userRequests.items[index - 1].type === 11) {
                        dispatch(getGroupCurrentRequestThunkAction(props.userRequests.items[index - 1].uid, {}));
                    } else {
                        dispatch(setCurrentRequestThunkAction(props.userRequests.items[index - 1].uid, true, props.userRequests.items[index].type, { setDescription: props.setDescription }));
                    }
                }
            } else if ((side === "right") && (index !== props.userRequests.items.length - 1)) {
                dispatch(unsetCurrentDocumentAction());
                dispatch(unsetUserRequestAction());
                if (props.isLeader) {
                    if (props.userRequests.items[index + 1].type === 22) {
                        dispatch(getIndividualCoefficientCardThunkAction(
                            props.userRequests.items[index + 1].uid,
                            { setDescription: props.setDescription },
                        ));
                    } else if(props.userRequests.items[index + 1].entityType.code === "request:local-trip") {
                        dispatch(getLocalTripDetailThunk(props.userRequests.items[index + 1].uid, { setDescription: props.setDescription }));
                    } else {
                        dispatch(getCurrentLeaderRequestThunkAction(props.userRequests.items[index + 1].uid, false, { setDescription: props.setDescription }));
                    }
                } else {
                    if (props.userRequests.items[index + 1].type === 22) {
                        dispatch(getIndividualCoefficientCardThunkAction(
                            props.userRequests.items[index + 1].uid,
                            {
                                setDescription: props.setDescription,
                                markReviewed: true,
                                isReviewed: props.userRequests.items[index + 1].isReviewed,
                            },
                        ));
                    } else if (props.userRequests.items[index + 1].type === 11) {
                        dispatch(getGroupCurrentRequestThunkAction(props.userRequests.items[index + 1].uid, {}));
                    } else {
                        dispatch(setCurrentRequestThunkAction(props.userRequests.items[index + 1].uid, true, { setDescription: props.setDescription }));
                    }
                }
            }
        }
    }

    console.log(props.isLeader);
    return (
        <>
            {props.isLeader
                ? <div className="request-modal__leader ">
                    <div className="request-modal__leader__name">
                        {
                            props.reject
                                ? "отклонение заявки"
                                : props.leaveReasonTypeId
                        }
                    </div>
                    {
                        props.reject ?
                            <>
                                <span>
                                    {
                                        props.currentRequest.initiatorFullname
                                    }
                                </span>
                                <br />
                                <div className="request-modal__leader__orderNumber">

                                    {
                                        props.currentRequest.orderNumber ?
                                            <>
                                                Заявка № {props.currentRequest.orderNumber}
                                            </> : null
                                    }
                                </div>
                            </>
                            :
                            <div className="request-modal__leader__worker">
                                {props.userRequests?.items && props.userRequests.items[0].uid !== props.currentRequest.uid &&
                                    <img onClick={() => switchHandler("left", props.currentRequest.uid)}
                                        src={left}
                                        alt="left-vector" />
                                }
                                <span>
                                    {
                                        props.currentRequest.initiatorFullname
                                    }
                                </span>
                                {props.userRequests?.items && props.userRequests.items[props.userRequests.items.length - 1].uid !== props.currentRequest.uid &&

                                    <img onClick={() => switchHandler("right", props.currentRequest.uid)}
                                        src={right}
                                        alt="right-vector" />
                                }
                                <div>
                                    {/*{  props.typeText ? props.typeText :   "Заявка №"}*/}
                                    {/*{*/}
                                    {/*    props.currentRequest.orderNumber*/}
                                    {/*}*/}
                                </div>
                            </div>
                    }
                </div>
                : <div className="request-modal__header">
                    {props.userRequests && props.userRequests.items &&
                        props.userRequests.items[0].uid
                        !== props.currentRequest?.uid &&
                        <img onClick={() => switchHandler("left", props.currentRequest.uid)}
                            src={left}
                            alt="left-vector" />
                    }

                    <span>
                        {
                            props.typeText
                        }
                        {
                            props.number ?" № " + props.number: ""
                        }
                        {" "}
                        {
                            props.leaveReasonTypeId
                            // props.currentRequest.leaveTypeName
                        }
                    </span>
                    {props.userRequests && props.userRequests.items[props.userRequests.items.length - 1]?.uid !== props.currentRequest?.uid &&
                        <img onClick={() => switchHandler("right", props.currentRequest.uid)}
                            src={right}
                            alt="right-vector" />
                    }
                </div>
            }
        </>
    );
};

export default SwitchRequests;
